module.exports = __webpack_public_path__ + "static/media/bg.4f362da6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/bg.svg
// module id = 1432
// module chunks = 0